const zhSG= {
    login: {
      title: '登录',
      sign_in_btn: '登录'
    },
    bar: {
        logout: '退出登录',
        languages: '语言',
        settings: '打开设置'
    },
    language: {
      name: '中文（新加坡）',
    },
    attributePage: {
        title: '属性更改',
        viewChanges: '查看更改',
        dateTime: '日期',
        notificationType: '通知类型',
        notificationValue: '通知值',
        oldValue: '旧值',
        newValue: '新值',
        accept: '接受',
        reject: '拒绝',
    },
    Home: '主页',
    load: '正在执行初始加载…',
    Requested: "已请求",
    Viewed: "已查看",
    Executing: "正在执行",
    Completed: "已完成",
    Expired: "已过期",
    Cancelled: "已取消",
    Error: "错误",
    Rejected: "已拒绝",
    error: '出现问题；请稍后再试。',
    displayname: '显示名称',
    givenname: '姓名',
    surname: '姓氏',
    email: '电子邮件',
    mail: '电子邮件',
    name: '姓名',
    firstname: '姓名',
    lastname: '姓氏',
    footer_copyright: '保留所有权利。'
  };
  
  export default zhSG;
  